import { cva } from 'cva'

export const buttonV1Style = cva({
  base: [
    'inline-flex items-center justify-center gap-[5px] whitespace-nowrap transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring [&_svg]:pointer-events-none [&_svg]:size-[10px] [&_svg]:shrink-0',
    ['disabled:bg-gray-200', 'disabled:text-white', 'disabled:cursor-not-allowed'],
  ],

  variants: {
    variant: {
      primary: ['bg-primary', 'text-white', 'hover:bg-green-500'],
      ghost: ['bg-white', 'text-gray-900', 'hover:bg-gray-50', 'border-gray-200', 'border'],
      sub: ['bg-gray-100', 'text-gray-900', 'hover:bg-gray-200'],
      warn: ['bg-red-normal', 'text-white', 'hover:bg-red-dark'],
    },
    size: {
      xLarge: ['w-[180px]', 'min-h-[52px]', 'text-xl'],
      large: ['w-[180px]', 'h-11', 'text-lg'],
      small: ['min-w-[87px]', 'h-9', 'text-md'],
      xSmall: ['min-w-[71px]', 'h-7', 'text-xs'],
    },
    shape: {
      round: ['rounded-[5px]'],
      square: ['rounded-lg'],
    },
  },

  defaultVariants: {
    variant: 'primary',
    size: 'xLarge',
    shape: 'square',
  },
})
